import {Component} from 'react'

import './index.css'

const leftArrow = 'https://assets.ccbp.in/frontend/react-js/left-arrow-img.png'

const rightArrow =
  'https://assets.ccbp.in/frontend/react-js/right-arrow-img.png'

class ReviewsCarousel extends Component {
  state = {index: 0}

  getUser = index => {
    const {reviewsList} = this.props
    const userDetails = reviewsList[index]
    return userDetails
  }

  onRightArrow = () => {
    const {index} = this.state
    const {reviewsList} = this.props
    const len = reviewsList.length
    const updateIndex = index + 1
    // console.log(len)
    if (updateIndex < len) {
      this.setState({
        index: updateIndex,
      })
    } else {
      this.setState({
        index: len - 1,
      })
    }
  }

  onLeftArrow = () => {
    const {index} = this.state
    const updateIndex = index - 1
    // console.log(len)
    if (updateIndex > 0) {
      this.setState({
        index: updateIndex,
      })
    } else {
      this.setState({
        index: 0,
      })
    }
  }

  render() {
    const {index} = this.state
    const userDetails = this.getUser(index)
    const {imgUrl, username, companyName, description} = userDetails
    return (
      <div className="app-container">
        <div className="review-container">
          <h1 className="heading">Reviews</h1>
          <img src={imgUrl} alt={username} className="user-img" />
          <div className="buttons-container">
            <button
              type="button"
              data-testid="leftArrow"
              className="btn left-btn"
              onClick={this.onLeftArrow}
            >
              <img src={leftArrow} alt="left arrow" className="arrow-img" />
            </button>
            <p className="user-name">{username}</p>
            <button
              type="button"
              data-testid="rightArrow"
              className="btn right-btn"
              onClick={this.onRightArrow}
            >
              <img src={rightArrow} alt="right arrow" className="arrow-img" />
            </button>
          </div>
          <p className="company-name">{companyName}</p>
          <p className="description">{description}</p>
        </div>
      </div>
    )
  }
}

export default ReviewsCarousel
